if (!customElements.get('cart-line-selling-plan')) {
  customElements.define(
    'cart-line-selling-plan',
    class CartLineSellingPlan extends HTMLElement {
      constructor() {
        super();

        this.select = this.querySelector('select');
        this.button = this.querySelector('button');

        if (this.select) {
          this.select.addEventListener('change', this.onSelectChange.bind(this));
        }

        if (this.button) {
          this.button.addEventListener('click', this.onButtonClick.bind(this));
        }
      }

      get cartItems() {
        return this.closest('cart-drawer-items') || this.closest('cart-items');
      }

      onSelectChange(event) {
        this.updateSellingPlan(event.target.value || null, event);
      }

      onButtonClick(event) {
        event.preventDefault();
        this.updateSellingPlan(this.dataset.sellingPlanId, event);
      }

      updateSellingPlan(sellingPlanId, event) {
        const cartItems = this.cartItems;
        if (!cartItems) return;

        const quantity = parseInt(this.dataset.quantity, 10) || 1;
        cartItems.updateSellingPlan(this.dataset.line, sellingPlanId, quantity, event);
      }
    }
  );
}
